<template>
  <div class="detail" id="EmailDetail" v-loading="detailLoading">
    <div class="screen" v-if="route.params.type!=='5'">
      <!--      type来源：1.收件箱，2：草稿箱，3：发件箱-->
      <ElButton size="small" type="primary"
                @click="handleReply(route.params.type === '2'||route.params.type === '3' || targetEmailDetail?.originalPosition === 2 ?'resend':'')">
        {{
          route.params.type === '3' || route.params.type === '2' || targetEmailDetail?.originalPosition === 2 ? $t('common.resend') : $t("common.reply")
        }}
      </ElButton>
      <ElButton size="small" type="primary" v-if="route.params.type === '3'"
                @click="handleReply('')">
        {{ $t("common.reply") }}
      </ElButton>
      <ElButton v-if="route.params.type!=='2' && targetEmailDetail?.originalPosition !== 2 " size="small"
                type="primary"
                @click="handleReply('replayAll')">
        {{ $t("common.email.replyToAll") }}
      </ElButton>
      <ElButton size="small" @click="() => handleReply('forward')">{{ $t("common.email.forward") }}</ElButton>
      <ElDropdown size="small" @command="handleCommand">
        <ElButton size="small">
          {{ $t('common.mark.to') }}&nbsp;<el-icon><ArrowDown /></el-icon>
        </ElButton>
        <template #dropdown>
          <ElDropdownMenu>
            <ElDropdownItem :command="0">{{ $t("common.email.read") }}</ElDropdownItem>
            <ElDropdownItem :command="1">{{ $t("common.email.noread") }}</ElDropdownItem>
            <ElDropdownItem :command="2">{{ $t("common.email.starmark") }}</ElDropdownItem>
            <ElDropdownItem :command="3">{{ $t("common.cancel.mark") }}</ElDropdownItem>
          </ElDropdownMenu>
        </template>
      </ElDropdown>
      <ElDropdown
          size="small"
          @command="handleGroupEmail"
          v-if="(route.params.type === '1' || route.params.type === '3') && availableMoveTargets.length > 0"
      >
        <ElButton size="small">
          {{ $t('common.move.to') }}&nbsp;<el-icon><ArrowDown /></el-icon>
        </ElButton>
        <template #dropdown>
          <div class="dropdown-menu-wrapper" style="max-height: 300px;max-width: 180px; overflow-y: auto;">
            <ElDropdownMenu class="move-select">
              <ElDropdownItem
                  v-for="item in availableMoveTargets"
                  :key="item.id"
                  :command="item.id"
              >
                <template v-if="item.isSystemTarget">
                  <span style="color: #5e9ff8">{{ item.fileName }}</span>
                </template>
                <template v-else>
                  {{ item.fileName }}
                </template>
              </ElDropdownItem>
            </ElDropdownMenu>
          </div>
        </template>
      </ElDropdown>
      <ElButton size="small" v-else-if="route.params.type === '1' || route.params.type === '3'">
        {{ $t('common.move.to') }}&nbsp;<el-icon><ArrowDown /></el-icon>
      </ElButton>
      <ElButton size="small" v-if="route.params.type !== '4'" @click="() => requestDelMail(1)">{{
          $t("common.delete")
        }}
      </ElButton>
      <ElButton size="small" @click="() => requestDelMail(2)">{{ $t("common.delete.empty") }}</ElButton>
      <!--      <ElButton size="small">垃圾邮件</ElButton>-->
      <ElButton size="small" @click="() => handleBlack()">{{ $t("common.block") }}</ElButton>
      <ElButton size="small" @click="handlePrint">{{ $t("common.email.print") }}</ElButton>
      <ElButton size="small" v-if="canShowArchiveButton" type="primary" @click="showReturn">
        {{ $t("common.archives.return") }}
      </ElButton>
      <ElButton size="small" v-if="route.params.type === '4'" type="primary" @click="() => requestDelMail(0)">
        {{ $t("common.restore") }}
      </ElButton>
    </div>
    <div v-else class="screen">
      <ElButton size="small" @click="passCheck" v-if="route.params.type === '5'" type="primary">
        {{ $t("common.pass") }}
      </ElButton>
      <ElButton size="small" @click="handleReject" v-if="route.params.type === '5'" type="danger">
        {{ $t("common.reject") }}
      </ElButton>
      <ElButton size="small" v-if="route.params.type === '6'" type="primary">
        {{ $t("common.followup") }}
      </ElButton>
      <ElButton size="small" v-if="route.params.type === '6'" type="warning">
        {{ $t("common.delay") }}
      </ElButton>
      <ElButton size="small" v-if="route.params.type === '6'" type="danger">
        {{ $t("common.sss16") }}
      </ElButton>
    </div>
    <div class="info">
      <div class="info_item border">
        <div class="title">
          <div class="label">
            <span>{{ $t("common.email.from") }}</span>
          </div>
        </div>
        <div class="cnt">
          {{ currentMail.mailBody?.from }}
        </div>
      </div>
      <div class="info_item border">
        <div class="title">
          <div class="label">
            <span>{{ $t('common.email.to') }}</span>
          </div>
        </div>
        <div class="cnt">
          {{ formatText(currentMail.mailRecipientVOList, 'to') }}
        </div>
      </div>
      <!--      {{ currentMail.mailRecipientVOList }}-->
      <div class="info_item border"
           v-if="currentMail.mailRecipientVOList?.filter(item=>item.mailType==='cc').length>=1">
        <div class="title">
          <div class="label">
            <span>{{ $t("common.cc") }}</span>
          </div>
        </div>
        <div class="cnt">
          {{ formatText(currentMail.mailRecipientVOList, 'cc') }}
        </div>
      </div>
      <div class="info_item border"
           v-if="currentMail.mailRecipientVOList?.filter(item=>item.mailType==='bcc').length>=1">
        <div class="title">
          <div class="label">
            <span>{{ $t("common.bcc") }}</span>
          </div>
        </div>
        <div class="cnt">
          {{ formatText(currentMail.mailRecipientVOList, 'bcc') }}
        </div>
      </div>
      <div class="info_item border">
        <div class="title">
          <div class="label"><span>{{ $t("common.subject") }}</span></div>
        </div>
        <div class="cnt">{{ currentMail.mailBody?.subject }}</div>
      </div>
      <div class="info_item border">
        <div class="title">
          <div class="label"><span>{{ $t("common.date") }}</span></div>
        </div>
        <div class="cnt">{{ currentMail.mailBody?.sentDate }}</div>
      </div>
      <!--      {{ JSON.parse(route.params.flag).isExtend }}-->
      <div class="info_item" v-if="rowItem.isExtend===1">
        <div class="title">
          <div class="label"><span>{{ $t("common.fj") }}</span></div>
        </div>
        <div class="cnt" style="margin-right: 10px;">
          {{ currentMail.mailExtendList?.length }}个
          <template v-if="currentMail.mailExtendList.length">
            (
            <svg v-if="currentMail.mailExtendList.length>1" t="1711952641079" class="icon" viewBox="0 0 1024 1024"
                 version="1.1"
                 xmlns="http://www.w3.org/2000/svg" p-id="11851" width="20" height="20">
              <path
                  d="M544 128h-288c-19.2 0-32 12.8-32 32v704c0 19.2 12.8 32 32 32h512c19.2 0 32-12.8 32-32v-480h-192c-35.2 0-64-28.8-64-64v-192z m64 12.8v179.2h179.2l-179.2-179.2z m-352-76.8h352c9.6 0 16 3.2 22.4 9.6l224 224c6.4 6.4 9.6 12.8 9.6 22.4v544c0 54.4-41.6 96-96 96h-512c-54.4 0-96-41.6-96-96v-704c0-54.4 41.6-96 96-96z m64 352h160c19.2 0 32 12.8 32 32s-12.8 32-32 32h-160c-19.2 0-32-12.8-32-32s12.8-32 32-32z m0 128h384c19.2 0 32 12.8 32 32s-12.8 32-32 32h-384c-19.2 0-32-12.8-32-32s12.8-32 32-32z m0 128h384c19.2 0 32 12.8 32 32s-12.8 32-32 32h-384c-19.2 0-32-12.8-32-32s12.8-32 32-32z"
                  fill="#8a8a8a" p-id="11852"></path>
            </svg>
            <FileIcon v-else
                      :fileExtend="currentMail.mailExtendList[0].url?.substring(currentMail.mailExtendList[0].url.lastIndexOf('.')+1).toLocaleLowerCase()"
                      :fileUrl="currentMail.mailExtendList[0].url" :size="25"
                      :isAbbreviation="true"></FileIcon>
            <a @click="_scrollTo('file')">{{ currentMail.mailExtendList[0].name }}</a>
            )
          </template>
        </div>
        <el-button text size="small" @click="handleRefresh">
          <el-icon>
            <Refresh/>
          </el-icon>
          <span>{{ $t("detail.refresh.btn") }}</span>
        </el-button>
      </div>
      <div class="info_item border">
        <div class="title">
          <div class="label"><span>{{ $t("common.size") }}</span></div>
        </div>
        <div class="cnt">{{ formatSize(currentMail.contentSize) }}</div>
      </div>
    </div>
    <div class="content">
      <el-alert v-if="shouldShowTranslateAlert" type="info">
        <template #title>
          <svg t="1782118647307" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1781" width="25" height="25"><path d="M471.66 825.19a25 25 0 0 1-23.25-15.8l-106.13-268c-0.21-0.53-0.33-0.83-1.22-0.83s-1 0.3-1.23 0.84l-106.12 268a25 25 0 1 1-46.49-18.4l106.13-268a51.31 51.31 0 0 1 95.42 0L494.9 791a25 25 0 0 1-23.24 34.21z" p-id="1782" fill="#2d2d31"></path><path d="M318.27 736.64h-54.69a25 25 0 1 1 0-50h54.69a25 25 0 0 1 0 50zM253 478.31a25 25 0 0 1-25-25v-99.62C228 276.11 291.11 213 368.69 213H408l-2.31-2.32A25 25 0 1 1 441 175.33l27.33 27.33a35.35 35.35 0 0 1-25 60.34h-74.64A90.79 90.79 0 0 0 278 353.69v99.62a25 25 0 0 1-25 25zM640 825a24.9 24.9 0 0 1-17.62-7.27l-33-32.82a35.75 35.75 0 0 1 25.21-61.1h73.56a90.8 90.8 0 0 0 90.69-90.69V533.5a25 25 0 0 1 50 0v99.62c0 77.57-63.12 140.69-140.69 140.69h-39l8.51 8.46A25 25 0 0 1 640 825zM772.57 412.62H595.33a60.49 60.49 0 0 1-60.43-60.43V294.7a60.5 60.5 0 0 1 60.43-60.44h177.24A60.5 60.5 0 0 1 833 294.7v57.49a60.49 60.49 0 0 1-60.43 60.43zM595.33 284.26a10.45 10.45 0 0 0-10.43 10.44v57.49a10.44 10.44 0 0 0 10.43 10.43h177.24A10.44 10.44 0 0 0 783 352.19V294.7a10.45 10.45 0 0 0-10.43-10.44z" p-id="1783" fill="#2d2d31"></path><path d="M684 513.32a25 25 0 0 1-25-25V175a25 25 0 0 1 50 0v313.32a25 25 0 0 1-25 25z" p-id="1784" fill="#2d2d31"></path></svg>
          <span style="font-size:13px;color:var(--el-text-color-regular);margin-left:10px;">{{ translateAlertText }}</span>
          <el-button
              link
              type="primary"
              :loading="translateMailContentLoading"
              @click="handleTranslateMailContent"
          >{{ translateButtonText }}</el-button>
        </template>
      </el-alert>
      <!--      {{ currentMail.mailExtendList}}-->
      <div v-loading="iframeLoad && !detailLoading" class="mail-content-frame">
        <iframe v-if="hasIframeContent" :key="iframeRenderToken" frameborder="0"
                id="pageframe"
                ref="iframeRef"
                :class="iframeLoad ? '' : 'loaded'"
                :srcdoc="iframeContent"
                style="width: 100%;height: 100%"
                @load="handleIframeLoad"
        ></iframe>
      </div>
      <EmailBrowser style="display: none;" ref="EmailBrowserRef" :content="iframeContent" :isPageEqResize="true"/>
      <div class="files" id="file" v-if="currentMail.mailExtendList.length">
        <div class="tips"
             style="padding-left: 25px !important;height: max-content;display: flex;align-items: center;padding-top: 12px">
          <div style="display: flex;align-items: center">
            {{ $t("displace.email.numberAttachments", currentMail.mailExtendList.length) }}
          </div>
          <el-button type="primary" text style="margin-left: 20px;color: #0a84ff;cursor: pointer" @click="downloadZip"
                     :loading="downloading">
            {{ $t("package.download") }}
          </el-button>
        </div>
        <div class="file_list">
          <div class="file" v-for="(item, index) in currentMail.mailExtendList" :key="index">
            <div class="file_info">
              <div class="img_wrap">
                <FileIcon :fileExtend="item.url?.substring(item.url.lastIndexOf('.')+1).toLocaleLowerCase()"
                          :fileUrl="item.url"
                          :isAbbreviation="true"></FileIcon>
              </div>
              <div class="name">
                <div class="t">{{ item.name }}</div>
                <div class="size">{{ formatSize(item.extendSize) || '-' }}</div>
              </div>
            </div>
            <div class="download_wrap">
              <a @click="handleDownload(item.url, item.name)">{{ $t("common.download") }}</a>
              <a v-if="isEmlAttachment(item)" @click="handleEmlAttachment(item)">{{ $t("common.preview") }}</a>
              <a @click="handleDetailFile(item)"
                 v-else-if="suportFile.includes(item.url?.substring(item.url.lastIndexOf('.') + 1).toLocaleLowerCase())">{{
                  $t("common.preview")
                }}</a>
              <a @click="handleReSave(item,'1')">{{ $t("common.cloud.Rollover") }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ReturnEmails ref="emailsReturn" v-if="dialogVisible" v-model="dialogVisible" @close="close"
                  @createCustomer="createdNewCustomer" :targetEmail="activeItemRow"

    ></ReturnEmails>
    <CustomerCreated ref="customerCreated" v-if="dialogVisibleCreatedMessage"
                     v-model="dialogVisibleCreatedMessage" @close="closeCreated" :innerDialog="dialogVisible"
                     @changeInnerDialog="close"></CustomerCreated>

    <BlackConfirmModal :showFlag="blackModalShow" :list="currentMail.mailBody?.from ? [currentMail.mailBody?.from] : []"
                       @succ="handleBlackSucc" @cancel="handleBlackCancel"/>

    <!--  移动对话框-->
    <MoveTargetFile v-if="moveTargetFileVisitable" v-model="moveTargetFileVisitable"
                    @close="closeMoveTarget" :is-head-line="true" :type="typeMove" :activeItem="activeItem"
                    :list="getFileList" :numberFlag="'2'" :mail="true"></MoveTargetFile>

    <!--    回执邮件-->
    <ReadTheReceipt v-if="dialogVisiblePopover" v-model="dialogVisiblePopover" @close="closeDialog"
                    :targetEmailDetail="targetEmailDetail"></ReadTheReceipt>
    <EmlPreviewDialog v-model="emlPreviewVisible" :attachment="emlPreviewAttachment" />

  </div>
</template>

<script>
import {computed, nextTick, onMounted, reactive, ref} from 'vue';
import {useRoute, useRouter} from 'vue-router';
import {getMailDetails, tagMail, delMail, downZip, groupEmail} from '../../api/index';
import {requestMailAccessory} from '../../api/mail';
import {
  audioFormat,
  downloadFile,
  excelFormat,
  formatSize,
  imgFormat,
  isEmlFile,
  pdfFormat,
  pptFormat,
  textFormat, videoFormat,
  wordFormat
} from '../../utils/file';
import {ElMessage} from 'element-plus';
import EmailBrowser from '../components/EmailBrowser.vue';
import BlackConfirmModal from '../components/BlackConfirmModal.vue';
import MyTitles from "@/views/Customer/Detail/MyTitles.vue";
import Dialog from "@/components/Dialog.vue";
import Forms from "@/views/Customer/CreateCheck/Forms.vue";
import {i18n} from "@/lang";
import {useStore} from "vuex";
import {emailReg, TIME_OUT} from "@/utils/statusParams";
import {ArrowDown, Plus} from "@element-plus/icons-vue";
import ReturnEmails from "@/components/DiaPops/Returns/ReturnEmails.vue";
import CustomerCreated from "@/components/DiaPops/Returns/CustomerCreated.vue";
import FileIcon from "@/components/File/FileIcon.vue";
import EmlPreviewDialog from "@/components/EmlPreviewDialog.vue";
import {throttle} from "@/utils/mylodash"
import {api as viewerApi} from "v-viewer";
import {bindIframeLinkClickToNewTab, containsHtmlTags, convertLinksToHTML, convertToHTML} from "@/utils/iframe";
import MoveTargetFile from "@/views/Cloud/Components/MoveTargetFile.vue";
import ReadTheReceipt from "@/components/DiaPops/ReadTheReceipt.vue";
import DeleteSelectTaskItem from "@/components/DiaPops/DeleteSelectTaskItem.vue";
import {replaceEmptyPTagsWithBr, resetCss} from "@/utils/TinyMCE";
import {updateMailCustomerAudit} from "@/api/customer";
import {extractMailVisibleText, translateMailHtmlContent} from "@/mail/translator";
import {splitHtmlAtFirstOriginalMessage} from "@/utils/util";
import {safeJSONParse} from "@/utils/json";

const commandList = [1, 0, 1, 0];
const MOVE_TO_ORIGINAL = '__MOVE_TO_ORIGINAL__';
export default {
  computed: {
    Plus() {
      return Plus
    },
    suportFile() {
      return [...imgFormat, ...pdfFormat, ...wordFormat, ...excelFormat, ...excelFormat, ...videoFormat, ...audioFormat, ...pptFormat, ...textFormat]
    }
  },
  methods: {
    imgFormat() {
      return imgFormat
    },
    formatSize,
    emailReg() {
      return emailReg
    }
  },
  components: {
    EmlPreviewDialog,
    DeleteSelectTaskItem,
    ReadTheReceipt,
    MoveTargetFile,
    FileIcon,
    CustomerCreated, ReturnEmails,
    Forms, Dialog, MyTitles,
    EmailBrowser,
    BlackConfirmModal,
  },
  setup() {
    // 点击 右侧查看文件
    const store = useStore()
    const route = useRoute();
    const router = useRouter();
    const id = computed(() => route.params.id);
    const rowItem = computed(() => safeJSONParse(route.params.flag, {}))
    const iframeContent = ref('');
    const iframeRef = ref(null);
    const EmailBrowserRef = ref(null);
    const blackModalShow = ref(false);
    const detailLoading = ref(true);
    const currentMail = ref({
      mailExtendList: [],
    });
    const emlPreviewVisible = ref(false);
    const emlPreviewAttachment = ref(null);

    // 对话框
    const dialogVisible = ref(false);
    // 对话框中的建档
    const dialogVisibleCreatedMessage = ref(false);
    const forms = reactive({email: '', customerName: '', merge: true, contactName: ''})
    const optionsCustomers = ref([])
    // 联系人
    const contactPerson = [{
      label: i18n.global.t('common.email.existingContacts'),
      value: true
    }, {label: i18n.global.t('common.email.newContacts'), value: false}];
    // 手动筛选联系人列表
    const contactList = ref([])
    // 联系人姓名
    // const contactName = ref([])
    // 表单校验规则
    const rules = reactive({
      name: [{required: true, message: i18n.global.t('sys.tip.input.name'), trigger: ["blur", "change"]}],
    });
    const teamId = computed(() => store.state.email.teamID);
    const ruleForm = computed(() => store.state.customer.ruleForm);
    // 区域列表
    const areaList = computed(() => store.state.customer.areaList);
    // 客户等级
    const tableDataLevel = computed(() => store.state.cusList.tableData);
    // 保存客户信息
    const childRef = ref(null)
    const targetEmailDetail = ref(null)
    const iframeLoad = ref(false);
    const hasIframeContent = ref(false);
    const iframeRenderToken = ref(0);
    const iframeLoadingStartedAt = ref(0);
    const CONTENT_SWITCH_LOADING_MIN_DURATION = 180;
    const originalMailContent = ref('');
    const translatedMailContent = ref('');
    const isShowingTranslatedMail = ref(false);
    const translateMailContentLoading = ref(false);
    const lastIframeContent = ref('');
    const userInfo = computed(() => store.state.user.userInfo || {});
    const lang = computed(() => store.state.system.langLocal || 'zh-CN');
    const canShowArchiveButton = computed(() => {
      const flag = currentMail.value?.mailBody?.flag ?? rowItem.value?.flag;
      return flag === 1 && (route.params.type === '1' || route.params.type === '3');
    });
    const mailUserId = computed(() => {
      const nextUserId = targetEmailDetail.value?.userId ?? currentMail.value?.userId ?? userInfo.value?.id;
      return nextUserId === undefined || nextUserId === null ? '' : String(nextUserId);
    });
    const currentFileGroupId = computed(() => String(currentMail.value?.mailBody?.fileGroupId || currentMail.value?.fileGroupId || ''));
    const isFolderDetail = computed(() => Boolean(currentFileGroupId.value));
    const targetFileList = computed(() => {
      if (!isFolderDetail.value) {
        return store.state.sidebar.targetFileList;
      }
      return [{
        id: MOVE_TO_ORIGINAL,
        fileName: i18n.global.t('common.move.back.original'),
        isSystemTarget: true,
      }, ...store.state.sidebar.targetFileList];
    });
    const availableMoveTargets = computed(() => {
      return targetFileList.value.filter(item => String(item.id) !== currentFileGroupId.value);
    });

    function getSystemPrimaryLanguage(langValue) {
      return String(langValue || '').toLowerCase().startsWith('zh') ? 'zh' : 'en';
    }

    function detectMailLanguage(content) {
      const plainText = extractMailVisibleText(content);
      if (!plainText) {
        return '';
      }

      const chineseChars = plainText.match(/[\u3400-\u4dbf\u4e00-\u9fff]/g) || [];
      const englishWords = plainText.match(/[A-Za-z]+/g) || [];

      if (chineseChars.length >= 8 && chineseChars.length >= englishWords.length) {
        return 'zh';
      }

      if (englishWords.length >= 8 && englishWords.length > chineseChars.length) {
        return 'en';
      }

      if (plainText.replace(/\s+/g, '').length >= 8) {
        return 'other';
      }

      return '';
    }

    const mailContentLanguage = computed(() => {
      return detectMailLanguage(currentMail.value?.mailBody?.content);
    });
    const systemPrimaryLanguage = computed(() => getSystemPrimaryLanguage(lang.value));
    const shouldShowTranslateAlert = computed(() => {
      return !!mailContentLanguage.value && mailContentLanguage.value !== systemPrimaryLanguage.value;
    });
    const translateTargetLabel = computed(() => {
      return systemPrimaryLanguage.value === 'zh' ? '中文' : 'English';
    });
    const translateAlertText = computed(() => {
      if (translatedMailContent.value) {
        if (systemPrimaryLanguage.value === 'zh') {
          return isShowingTranslatedMail.value
            ? '当前显示译文，可切换查看原文'
            : `当前显示原文，可切换查看${translateTargetLabel.value}译文`;
        }
        return isShowingTranslatedMail.value
          ? 'Showing translated content. Switch back to the original email anytime.'
          : `Showing original content. Switch to the ${translateTargetLabel.value} translation anytime.`;
      }

      return systemPrimaryLanguage.value === 'zh'
        ? `邮件可翻译为${translateTargetLabel.value}`
        : `This email can be translated to ${translateTargetLabel.value}`;
    });
    const translateButtonText = computed(() => {
      if (translateMailContentLoading.value) {
        return systemPrimaryLanguage.value === 'zh' ? '翻译中...' : 'Translating...';
      }
      if (translatedMailContent.value) {
        if (isShowingTranslatedMail.value) {
          return systemPrimaryLanguage.value === 'zh' ? '查看原文' : 'View original';
        }
        return systemPrimaryLanguage.value === 'zh' ? '查看翻译' : 'View translation';
      }
      return systemPrimaryLanguage.value === 'zh' ? '翻译邮件内容' : 'Translate email content';
    });

    function hasDocumentWrapper(content) {
      return /<(html|head|body)\b/i.test(String(content || ''));
    }

    function injectResetCss(content) {
      const safeContent = String(content || '');
      if (!safeContent) {
        return resetCss;
      }

      if (!containsHtmlTags(safeContent) || !hasDocumentWrapper(safeContent)) {
        return resetCss + safeContent;
      }

      const parser = new DOMParser();
      const doc = parser.parseFromString(safeContent, 'text/html');
      const styleDoc = parser.parseFromString(resetCss, 'text/html');
      const styleFragment = doc.createDocumentFragment();
      Array.from(styleDoc.head.childNodes || []).forEach((node) => {
        styleFragment.appendChild(doc.importNode(node, true));
      });
      doc.head.prepend(styleFragment);

      return doc.documentElement.outerHTML;
    }

    function buildIframeContent(content) {
      const safeContent = String(content || '');
      if (!safeContent) {
        return replaceEmptyPTagsWithBr(injectResetCss(''));
      }

      if (containsHtmlTags(safeContent)) {
        return replaceEmptyPTagsWithBr(injectResetCss(safeContent));
      }

      if (safeContent.indexOf('https://s3gw.cmbimg.com') !== -1) {
        return replaceEmptyPTagsWithBr(injectResetCss(safeContent));
      }

      return replaceEmptyPTagsWithBr(injectResetCss(convertLinksToHTML(convertToHTML(safeContent))));
    }

    function syncIframeContent(options = {}) {
      const {showLoading = false, force = false} = options;
      const effectiveContent = translatedMailContent.value && isShowingTranslatedMail.value
        ? translatedMailContent.value
        : originalMailContent.value;
      if (!force && hasIframeContent.value && effectiveContent === lastIframeContent.value) {
        return;
      }
      iframeRenderToken.value += 1;
      if (showLoading && hasIframeContent.value) {
        iframeLoadingStartedAt.value = Date.now();
        iframeLoad.value = true;
      }
      lastIframeContent.value = effectiveContent;
      hasIframeContent.value = true;
      iframeContent.value = buildIframeContent(effectiveContent);
    }

    async function handleIframeLoad() {
      bindIframeLinkListener();
      const currentToken = iframeRenderToken.value;
      const shouldKeepLoading = iframeLoad.value && !detailLoading.value;
      if (shouldKeepLoading) {
        const elapsed = Date.now() - iframeLoadingStartedAt.value;
        const remaining = Math.max(CONTENT_SWITCH_LOADING_MIN_DURATION - elapsed, 0);
        if (remaining > 0) {
          await new Promise((resolve) => setTimeout(resolve, remaining));
        }
      }
      if (currentToken !== iframeRenderToken.value) {
        return;
      }
      detailLoading.value = false;
      if (shouldKeepLoading) {
        iframeLoad.value = false;
      }
      iframeLoad.value = false;
    }

    // 邮件正文中的链接/按钮点击后在新标签页打开对应地址
    // iframe 通过 iframeRenderToken 重建，旧监听随旧 iframe 一并销毁，无需额外清理
    function bindIframeLinkListener() {
      bindIframeLinkClickToNewTab(iframeRef.value?.contentDocument);
    }

    async function translateMailContent(content) {
      const targetLanguage = systemPrimaryLanguage.value === 'zh' ? 'zh' : 'en';
      const result = await translateMailHtmlContent({
        emailId: id.value ? String(id.value) : '',
        html: content,
        source: mailContentLanguage.value || 'auto',
        target: targetLanguage,
      });

      if (!result?.translatedHtml) {
        throw new Error(systemPrimaryLanguage.value === 'zh' ? '未获取到翻译结果' : 'No translation result was returned');
      }

      return result.translatedHtml;
    }

    function getTranslateMailSegments(mailContent) {
      const {
        hasOriginalMessage,
        translatableHtml,
        originalMessageHtml,
      } = splitHtmlAtFirstOriginalMessage(mailContent);

      return {
        hasOriginalMessage,
        translatableHtml: String(translatableHtml || ''),
        originalMessageHtml: String(originalMessageHtml || ''),
      };
    }

    async function handleTranslateMailContent() {
      if (translateMailContentLoading.value) {
        return;
      }

      if (translatedMailContent.value) {
        isShowingTranslatedMail.value = !isShowingTranslatedMail.value;
        syncIframeContent({showLoading: true});
        return;
      }

      const mailContent = String(originalMailContent.value || '');
      if (!mailContent.trim()) {
        ElMessage.warning(systemPrimaryLanguage.value === 'zh' ? '暂无可翻译内容' : 'No content available to translate');
        return;
      }

      translateMailContentLoading.value = true;
      translatedMailContent.value = '';
      isShowingTranslatedMail.value = false;

      try {
        const {
          translatableHtml,
          originalMessageHtml,
        } = getTranslateMailSegments(mailContent);
        console.log(getTranslateMailSegments(mailContent),'getTranslateMailSegments(mailContent)')
        if (!translatableHtml.trim()) {
          ElMessage.warning(systemPrimaryLanguage.value === 'zh' ? '暂无可翻译内容' : 'No content available to translate');
          return;
        }

        const translatedContent = await translateMailContent(translatableHtml);
        if (!translatedContent) {
          throw new Error(systemPrimaryLanguage.value === 'zh' ? '翻译结果为空' : 'The translation result is empty');
        }
        translatedMailContent.value = `${translatedContent}${originalMessageHtml}`;
        isShowingTranslatedMail.value = true;
        syncIframeContent({showLoading: true});
      } catch (error) {
        console.error('translate mail content failed:', error);
        ElMessage.error(error?.message || (systemPrimaryLanguage.value === 'zh' ? '翻译失败，请稍后重试' : 'Translation failed, please try again later'));
      } finally {
        translateMailContentLoading.value = false;
      }
    }

    async function loadTargetFileList() {
      if (!mailUserId.value || !(route.params.type === '1' || route.params.type === '3')) {
        return;
      }
      await store.dispatch("sidebar/getEmailGroupFileListApis", {
        teamId: teamId.value,
        userId: mailUserId.value
      });
    }

    async function getDetail() {
      try {
        detailLoading.value = true;
        iframeLoad.value = false;
        translateMailContentLoading.value = false;
        const result = await getMailDetails({id: id.value});
        let content = result.result?.mailBody?.content;
        originalMailContent.value = String(content || '');
        translatedMailContent.value = '';
        isShowingTranslatedMail.value = false;
        targetEmailDetail.value = result.result?.mailBody;
        currentMail.value = result.result;
        // const insertionContent = `<script>
        //     function errorImage(img) {
        //         console.log(img,'img')
        //         img.onerror = null;
        //         img.src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAADElEQVR42mP4//8/AAX+Av4zEpUUAAAAAElFTkSuQmCC"
        //     }
        // <\/script>`;
        syncIframeContent({force: true});
      } catch (e) {
        detailLoading.value = false;
        iframeLoad.value = false
      }
    }

    async function getMailAccessory() {
      const result = await requestMailAccessory({id: id.value});
      console.log(result, '获取附件');
    }

    async function requestDelMail(flag) {
      // 构建请求参数
      const params = {
        type: flag, // 0 还原  1 已删除 2彻底删除
        mailIdList: [currentMail.value.mailBody.id],
      };
      
      // 只有 type: 1 时才需要传递 originalPosition
      if (flag === 1) {
        params.originalPosition = route.params.type - 0;
      }
      
      const result = await delMail(params);
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      if (flag === 0) {
        getDetail();
      }
      if (flag === 1 || flag == 2) {
        router.replace('/email/inbox');
      }
    }

    function handleBlack() {
      blackModalShow.value = true;
    }

    function handleBlackSucc() {
      blackModalShow.value = false;
      router.replace('/email/inbox');
    }

    function handleBlackCancel() {
      blackModalShow.value = false;
    }

    async function requestTagMail(tag, type, val) {
      const result = await tagMail({
        [type]: tag,
        mailIdList: [currentMail.value.mailBody.id],
      });
      console.log('标记邮件', result);
      if (result.code !== 200) {
        ElMessage.error(result.message);
        return;
      }
      currentMail.value = {
        ...currentMail.value,
        mailBody: {
          ...currentMail.value.mailBody,
          [type]: tag,
        },
      };
      if (targetEmailDetail.value) {
        targetEmailDetail.value = {
          ...targetEmailDetail.value,
          [type]: tag,
        };
      }
      await store.dispatch('countshow/getTeamAllDataApis');
    }

    function handlePrint() {
      EmailBrowserRef.value.printPage();
      console.log(EmailBrowserRef.value, 'dom')
    }

    function formatText(list, type) {
      console.log(list, type);
      if (!list || !list.length) {
        return '';
      }
      const infoMap = list.reduce((prev, item) => {
        if (!prev[item.mailType]) {
          prev[item.mailType] = [];
        }
        prev[item.mailType].push(item.mail);
        return prev;
      }, {});
      return infoMap[type] ? infoMap[type].join(',') : '';
    }

    function handleReply(type = '') {
      console.log(currentMail, 'currentMail');
      if (!currentMail.value.mailBody?.id) {
        return;
      }
      const targetType = route.params.type
      const targetFlag = rowItem.value || {}

      //route.params.type 代表哪个入口进来:1.收件箱,2:草稿箱,3:发件箱 mailType
      if (targetType !== '2' && type === 'resend' || targetEmailDetail.value.originalPosition === 2) {
        const query = {
          id: currentMail.value.mailBody.id,
          flag: targetFlag.flag,
          type,
          mailType: route.params.type,
          customerId: targetFlag.customerId
        };

        // const queryString = new URLSearchParams(query).toString();
        //
        // // 构造 URL 并在新标签页中打开（假设使用 history 模式）
        // const url = `${location.origin}/email/write_mail?${queryString}`;
        // window.open(url, '_blank');
        router.push({
          path: '/email/write_mail',
          query,
        });
      } else {
        const query = {
          id: currentMail.value.mailBody.id,
          type,
          mailType: route.params.type,
          customerId: targetFlag.customerId
        }
        if (type === "") {
          delete query.type;
        }
        console.log(query, 'payload')
        router.push({
          path: '/email/write_mail',
          query,
        });
        // const queryString = new URLSearchParams(query).toString();
        // // 构造 URL 并在新标签页中打开（假设使用 history 模式）
        // const url = `${location.origin}/email/write_mail?${queryString}`;
        // window.open(url, '_blank');
      }
    }

    function handleCommand(val) {
      console.log(val);
      const type = val === 0 || val === 1 ? 'isRead' : 'isStress';
      requestTagMail(commandList[val], type, val);
    }

    async function handleGroupEmail(id) {
      const mailId = currentMail.value.mailBody?.id;
      if (!mailId) {
        ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
        return;
      }
      if (id === MOVE_TO_ORIGINAL) {
        const result = await delMail({
          type: 3,
          mailIdList: [mailId],
          teamId: teamId.value,
        });
        if (result.code !== 200) {
          ElMessage.error(result.message);
          return;
        }
        await store.dispatch('countshow/getTeamAllDataApis');
        await getDetail();
        return;
      }
      await groupEmailTarget(id);
    }

    async function groupEmailTarget(id) {
      try {
        const mailId = currentMail.value.mailBody?.id;
        if (!mailId) {
          ElMessage.error(i18n.global.t('sys.tip.unselect.email'));
          return;
        }
        const payload = {
          userId: mailUserId.value,
          fileGroupId: id,
          mailIdList: [mailId],
          originalPosition: Number(route.params.type),
        };
        const res = await groupEmail(payload);
        if (res.code !== 200) {
          ElMessage.error(res.message);
          return;
        }
        await store.dispatch('countshow/getTeamAllDataApis');
        await getDetail();
      } catch (e) {
      }
    }

    async function handleDownload(url, fileName) {
      try {
        if (!url) {
          ElMessage.error('文件地址无效');
          return;
        }

        // 强制 https（只替换开头为 http:// 的情况，不影响 https://）
        const safeUrl = url.replace(/^http:\/\//i, "https://");

        console.log(safeUrl, 'handleDownload');

        const response = await fetch(safeUrl, {method: "GET"});

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const blob = await response.blob();

        // 若 fileName 未传，则从 URL 推断
        if (!fileName) {
          fileName = safeUrl.split("/").pop() || "download";
        }

        downloadFile(blob, fileName);
        return true;
      } catch (error) {
        console.error('下载失败:', error);
        ElMessage.error("下载失败，请稍后重试");
        return false;
      }
    }

    const isEmlAttachment = (item = {}) => isEmlFile(item.name || item.fileName || item.url);

    const handleEmlAttachment = async (item) => {
      emlPreviewAttachment.value = item;
      emlPreviewVisible.value = true;
    };

    function _scrollTo(id) {
      var _id = document.getElementById(id);
      document.querySelector('.view').scrollTo({
        top: _id.offsetTop,
        behavior: 'smooth'
      });
    }


    const close = () => {
      dialogVisible.value = false;
    }
    const closeCreated = () => {
      dialogVisibleCreatedMessage.value = false;
    }

    const createdNewCustomer = () => {
      dialogVisibleCreatedMessage.value = true
      store.commit('customer/setRuleForm', {
        zoneCode: "",
        customerCode: "",
        zoneAddress: "",
        customerName: "",
        setUpTime: "",
        economicNature: "",
        companyWebsite: "",
        companyAddress: "",
        phoneWayList: [],
        emailWayList: [],
        companyFax: "",
        companyRemark: "",
        customerLevel: "",
        customerType: "",
        customerTypeId: "",
        product: "",
        marketingRemark: " ",
        createBy: "",
        branchAdmin: "",
        mangerVOList: [{managerName: ''}]
      });
    }

    const toEmailObj = (arr = []) => {
      return arr.filter(Boolean).map(item => ({email: item}));
    }

    // 编辑邮件信息
    const activeItemRow = ref([])
    const emailsReturn = ref(null)
    // 归档
    const showReturn = async () => {
      dialogVisible.value = true
      if (route.params.type === '3') {
        const recipientList = currentMail.value.mailRecipientList?.length
          ? currentMail.value.mailRecipientList
          : (currentMail.value.mailRecipientVOList || [])
            .filter(item => item.mailType === 'to')
            .map(item => item.mail);
        activeItemRow.value = toEmailObj(recipientList)
      } else {
        activeItemRow.value = currentMail.value.mailBody?.from ? [{email: currentMail.value.mailBody.from}] : []
      }

      await nextTick();
      await emailsReturn.value.getAllCustomers();
    }
    onMounted(async () => {
      await getDetail();
      await loadTargetFileList();

      // 阅读回执弹窗
      // console.log(targetEmailDetail.value.isReceipt, 'activeItem.value.isReceipt')
      if (targetEmailDetail.value.receipt && !targetEmailDetail.value.isReceipt) {
        dialogVisiblePopover.value = true
      }
      // 自动下载附件
      // 判断是否有附件如果有的话自动下载；如果没有附件则不需要下载
      console.log(targetEmailDetail.value.isExtend, 'targetEmailDetail.value')
      if (targetEmailDetail.value?.isExtend) {
        await getMailAccessory();
      }
    })


    // 页面刷新
    const handleRefresh = () => {
      location.reload();
    }

    // 文件移动
    const moveTargetFileVisitable = ref(false);
    const activeItem = ref([])
    const closeMoveTarget = () => {
      moveTargetFileVisitable.value = false
    }
    // 文件转存
    const handleReSave = throttle(async (item) => {
      console.log(item, "item")
      activeItem.value = [item]
      // const payload = {
      //   id: "0",
      //   idList: [item.id]
      // }
      // await store.dispatch("cloud/copyEmailFileApis", payload)
      moveTargetFileVisitable.value = true;
    }, TIME_OUT)

    // 文件预览
    const handleDetailFile = (item) => {
      if (isEmlAttachment(item)) {
        handleEmlAttachment(item);
        return;
      }
      const {url, name} = item
      // 获取扩展名
      const fileExtend = name.substring(name.lastIndexOf(".") + 1).toLocaleLowerCase()
      console.log(item, imgFormat.includes(fileExtend), fileExtend, 'item')

      if (imgFormat.includes(fileExtend)) {
        // 图片预览
        showTargetFile(item)
      } else if (pdfFormat.includes(fileExtend)) {
        // pdf
        //预览
        showTargetPdf(item);
      } else if (wordFormat.includes(fileExtend) || excelFormat.includes(fileExtend) || pptFormat.includes(fileExtend)) {
        // /world/excel
        window.open("https://view.officeapps.live.com/op/view.aspx?src=" + encodeURIComponent(item.url))
      } else if (textFormat.includes(fileExtend)) {
        showTargetText(item)
      } else if (videoFormat.includes(fileExtend)) {
        showTargetVideo(item)
      } else if (audioFormat.includes(fileExtend)) {
        showTargetAudio(item)
      } else {
        // alert('下载')
        handleDownload(item.url, item.name)
      }
    }

    function buildOpenUrl(basePath, row) {
      if (!row || !row.url || !row.name) {
        console.error('showTarget 函数缺少必要的 row 参数');
        return '';
      }

      // 修正 http → https（只替换开头 http://，不会影响 https://）
      const safeUrl = row.url.replace(/^http:\/\//i, "https://");

      // 获取扩展名
      const ext = row.name.substring(row.name.lastIndexOf(".") + 1).toLowerCase();

      // 构建统一 URL
      return `${location.origin}/${basePath}?url=${encodeURIComponent(safeUrl)}&type=${encodeURIComponent(ext)}`;
    }

    const showTargetPdf = (row) => {
      const url = buildOpenUrl("showfile", row);
      openNewWindow(url);
    };

    const showTargetText = (row) => {
      const url = buildOpenUrl("showtext", row);
      openNewWindow(url);
    };

    const showTargetVideo = (row) => {
      const url = buildOpenUrl("showvideo", row);
      openNewWindow(url);
    };

    const showTargetAudio = (row) => {
      let url = buildOpenUrl("showaudio", row);

      // audio 多加 title
      url += `&title=${encodeURIComponent(row.name)}`;

      openNewWindow(url);
    };

    const openNewWindow = (url) => {
      window.open(url, "_blank");
    };

    const showTargetFile = (row) => {
      // alert(row.name)
      let images = [];
      let initialViewIndex = 0;

      // 过滤出非文件夹的文件
      currentMail.value.mailExtendList.filter(_ => imgFormat.includes(_.name.substring(_.name.lastIndexOf(".") + 1).toLocaleLowerCase())).forEach((o, i) => {
        if (o.name === row.name) initialViewIndex = images.length
        images.push({src: o.url?.replace(/^http:\/\//i, "https://") || ""})
      })
      console.log(images, 'images')
      viewerApi({
        images,
        options: {
          initialViewIndex
        }
      })
    }


    const downloading = ref(false)
    const downloadZip = async () => {
      downloading.value = true
      await downZip({mailId: route.params.id}, {
        responseType: 'blob'
      }).then(res => {
        const blob = new Blob([res], {type: 'application/zip;charset=UTF-8'}); // 使用 ZIP 文件的 MIME 类型
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        var timestamp = Date.now();
        link.setAttribute('download', 'attachment_' + timestamp + '.zip');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href); // 清理创建的URL对象
        downloading.value = false
      }).catch(error => {
        downloading.value = false
        console.error('Error downloading file:', error);
      });
    };

// 获取所有数据
    const current = ref(1);
    const size = ref(40);
    const total = computed(() => store.state.cloud.total);
    const tableLoading = ref(false);
    const typeMove = reactive(2)
    const getFileList = async () => {
      tableLoading.value = true;
      if (typeMove === 1 || typeMove === 5 || typeMove === 6) {
        if (route.query.id) {
          checkRouter()
        } else {
          const params = {
            pageNo: current.value,
            pageSize: size.value,
            isHide: typeMove === 5 ? 2 : null,
            // 1 我的文件夹， 2 回收站
            type: typeMove === 1 ? typeMove : typeMove === 6 ? 2 : 1,
            parentId: "0"
          }
          if (params.isHide === null) {
            delete params.isHide;
          }
          if (typeMove !== 1) {
            delete params.parentId;
          }
          await store.dispatch('cloud/getFileListApi', params)
        }
      } else if (typeMove === 2) {
        const params = {
          pageNo: current.value,
          pageSize: size.value,
        }
        await store.dispatch("cloud/publicShareOtherListApis", params)
      } else if (typeMove === 3) {
        const params = {
          pageNo: current.value,
          pageSize: size.value,
        }
        await store.dispatch("cloud/myPublicShareListApis", params)
      } else if (typeMove === 4) {
        console.log(route.query.id, 'route.query.id')
        if (route.query.id) {
          checkRouter()
          await store.dispatch('cloud/queryShareFileByParentIdApi', {
            pageNo: current.value,
            pageSize: size.value,
            parentId: route.query.id,
          })
        } else {
          const params = {
            pageNo: current.value,
            pageSize: size.value,
          }
          await store.dispatch("cloud/mailFileShareListApis", params)
        }
      }
      tableLoading.value = false;
    }


    // 邮件回执
    const dialogVisiblePopover = ref(false)
    const closeDialog = () => {
      dialogVisiblePopover.value = false
    }


    // 操作邮件
    // 通过？驳回？
    const passCheck = async () => {
      const {id, recordId, customerName, userId} = currentMail.value;
      const targetObj = {
        auditStatus: 2,
        mailCustomerAndRecordIdDTOList: [{customerId: id, customerName, recordId, userId,}],
        teamId: teamId.value,
      };
      console.log('########', targetObj)
      let res = await updateMailCustomerAudit({...targetObj});
      if (res.code !== 200) {
        ElMessage.error(res.message);
        return;
      }
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis');
      router.replace('/email/inbox');
    };
    // 单行驳回
    const handleReject = async () => {
      const {id, recordId, customerName, userId} = currentMail.value;
      const targetObj = {
        auditStatus: 3,
        mailCustomerAndRecordIdDTOList: [{customerId: id, customerName, recordId, userId}],
        teamId: teamId.value,
      };
      let res = await updateMailCustomerAudit({...targetObj});
      if (res.code !== 200) {
        ElMessage.error(res.message);
        return;
      }
      // 更新标志
      await store.dispatch('countshow/getTeamAllDataApis');
      router.replace('/email/inbox');
    };


    return {
      passCheck,
      translateButtonText,
      translateAlertText,
      shouldShowTranslateAlert,
      translateMailContentLoading,
      handleTranslateMailContent,
      handleReject,
      canShowArchiveButton,
      detailLoading,
      downloading,
      hasIframeContent,
      availableMoveTargets,
      targetEmailDetail,
      typeMove,
      activeItem,
      closeDialog,
      dialogVisiblePopover,
      handleReSave,
      getFileList,
      closeMoveTarget,
      moveTargetFileVisitable,
      downloadZip,
      iframeLoad,
      handleDetailFile,
      handleRefresh,
      handleIframeLoad,
      createdNewCustomer,
      activeItemRow,
      emailsReturn,
      close,
      closeCreated,
      iframeContent,
      iframeRef,
      EmailBrowserRef,
      currentMail,
      emlPreviewVisible,
      emlPreviewAttachment,
      blackModalShow,
      iframeRenderToken,
      handleDownload,
      handleEmlAttachment,
      isEmlAttachment,
      formatText,
      handlePrint,
      handleReply,
      handleCommand,
      handleGroupEmail,
      requestDelMail,
      handleBlack,
      handleBlackSucc,
      handleBlackCancel,
      rowItem,
      dialogVisible,
      showReturn,
      dialogVisibleCreatedMessage,
      forms,
      contactList,
      ruleForm,
      areaList,
      tableDataLevel,
      optionsCustomers,
      rules,
      childRef,
      route,
      _scrollTo,
    }
  }
}
</script>

<style lang="less" scoped>
@import "../Customer/less/detail.less";
@import "less/detail";

.mail-content-frame {
  width: 100%;
  height: 100%;
  min-height: 320px;
}

#pageframe {
  background: transparent;
}

iframe {
  display: block;
  opacity: 0;
  transition: opacity 0.25s ease-in-out;
}

iframe.loaded {
  opacity: 1;
}

.move-select {
  .dropdown-menu-wrapper {
    min-width: auto !important;
    width: auto;
    max-width: 200px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  :deep(.el-dropdown-menu__item) {
    min-width: auto !important;
    width: auto;
    max-width: 200px !important;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    display: inherit !important;
  }
}

:deep(.el-alert__title){
  display:flex;
  height:100%;
  align-item:center;
}

:deep(.el-alert--info.is-light){
  background:#f3f7fa !important;
}
</style>
